import React, { useState } from 'react';
import api from '../api';

export default function ForgotPassword({ goToLogin }) {
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true); setError('');
    try {
      await api.post('/auth/forgot-password', { email });
      setSent(true);
    } catch (err) {
      setError(err.response?.data?.error || 'Something went wrong');
    }
    setLoading(false);
  };

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'transparent' }}>
      <div style={{ background: 'var(--glass-2)', backdropFilter: 'var(--blur)', WebkitBackdropFilter: 'var(--blur)', border: '1px solid var(--glass-border)', borderRadius: 16, padding: '40px 36px', width: 380, boxShadow: '0 20px 60px rgba(0,0,0,.3)' }}>
        <div style={{ textAlign: 'center', marginBottom: 28 }}>
          <div style={{ fontSize: '1.8rem', fontWeight: 800, color: 'var(--text)' }}>HR<span style={{ color: '#4f46e5' }}>Track</span></div>
          <div style={{ color: 'var(--muted)', marginTop: 6, fontSize: '0.9rem' }}>Reset your password</div>
        </div>

        {sent ? (
          <div style={{ textAlign: 'center' }}>
            <div style={{ fontSize: '2.5rem', marginBottom: 16 }}>📧</div>
            <h3 style={{ color: 'var(--text)', marginBottom: 8 }}>Check your email</h3>
            <p style={{ color: 'var(--muted)', marginBottom: 24 }}>If an account exists for <strong>{email}</strong>, we've sent a password reset link.</p>
            <button onClick={goToLogin} className="btn btn-primary" style={{ width: '100%', justifyContent: 'center', padding: '10px' }}>Back to Sign In</button>
          </div>
        ) : (
          <form onSubmit={handleSubmit}>
            <p style={{ color: 'var(--muted)', fontSize: '0.9rem', marginBottom: 20 }}>Enter your email and we'll send you a link to reset your password.</p>
            <div className="form-group">
              <label>Email Address</label>
              <input type="email" autoFocus value={email} onChange={e => setEmail(e.target.value)} placeholder="you@company.com" required />
            </div>
            {error && <div style={{ background: '#fee2e2', color: '#991b1b', padding: '8px 12px', borderRadius: 8, marginBottom: 14, fontSize: '0.875rem' }}>{error}</div>}
            <button type="submit" className="btn btn-primary" disabled={loading} style={{ width: '100%', justifyContent: 'center', padding: '10px' }}>
              {loading ? 'Sending…' : 'Send Reset Link'}
            </button>
            <p style={{ textAlign: 'center', marginTop: 16, fontSize: '0.875rem', color: 'var(--muted)' }}>
              <button onClick={goToLogin} style={{ background: 'none', border: 'none', color: '#4f46e5', cursor: 'pointer', fontWeight: 600 }}>← Back to Sign In</button>
            </p>
          </form>
        )}
      </div>
    </div>
  );
}
